import { ref, uploadBytes } from 'firebase/storage'
import { storage } from '../firebase'
import ensureSurveyFirebaseSession from './ensureSurveyFirebaseSession'

function safePathSegment(value, fallback) {
  const normalized = String(value || '').trim().replace(/[^a-zA-Z0-9_-]/g, '_')
  return normalized || fallback
}

export default async function uploadSurveyCameraRecording({
  surveyCode,
  responseId,
  questionNumber,
  stepId,
  blob,
  extension,
}) {
  if (!(blob instanceof Blob) || blob.size === 0) {
    throw new Error('Camera recording is empty')
  }

  const surveySegment = safePathSegment(surveyCode, 'survey')
  const responseSegment = safePathSegment(responseId, 'response')
  const stepSegment = safePathSegment(stepId, `question_${questionNumber}`)
  const fileExtension = safePathSegment(extension, 'webm')
  const fileName = `question_${questionNumber}_${stepSegment}_${Date.now()}.${fileExtension}`
  const storagePath = `surveys/${surveySegment}/responses/${responseSegment}/camera/${fileName}`
  const recordingReference = ref(storage, storagePath)
  const firebaseUser = await ensureSurveyFirebaseSession()

  const snapshot = await uploadBytes(recordingReference, blob, {
    contentType: blob.type || 'application/octet-stream',
    customMetadata: {
      surveyCode: String(surveyCode || ''),
      responseId: String(responseId || ''),
      questionNumber: String(questionNumber || ''),
      stepId: String(stepId || ''),
      ownerUid: firebaseUser.uid,
    },
  })

  return {
    storage_path: snapshot.ref.fullPath,
    byte_size: snapshot.metadata.size,
    content_type: snapshot.metadata.contentType || blob.type,
  }
}
